import TeachingLearningSequenceInlineSvg from 'approot/shared/inline-svg/teaching-learning-sequence/teaching-learning-sequence-inline-svg';
import { SecondaryButtonAndIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import { ValidSpacings, spacing8 } from 'approot/shared/styles/spacing.style';
import { TeachingLearningSequencePillWrapper } from './teaching-learning-sequence.style';

const TeachingLearningSequenceCheckpointButtons = ({
  isCheckPoint,
  isFurtherEnrichment,
  onClickCheckPoint,
  onClickFurtherEnrichment,
  marginBottom,
  gap,
}: {
  isCheckPoint?: boolean;
  isFurtherEnrichment?: boolean;
  onClickCheckPoint?: () => void;
  onClickFurtherEnrichment?: () => void;
  marginBottom?: ValidSpacings;
  gap?: number;
}) => {
  if (!isCheckPoint && !isFurtherEnrichment) return null;

  return (
    <TeachingLearningSequencePillWrapper
      $marginBottom={marginBottom === undefined ? 24 : marginBottom}
      $gap={gap === undefined ? spacing8 : gap}
    >
      {isCheckPoint && (
        <SecondaryButtonAndIcon
          $isSmall
          type="button"
          aria-haspopup="dialog"
          aria-label="Checkpoint. Click to view more information."
          onClick={onClickCheckPoint}
          data-selector="checkpoint-pill"
        >
          Checkpoint{' '}
          <TeachingLearningSequenceInlineSvg
            id="icon_star"
            width={18}
            height={18}
          />
        </SecondaryButtonAndIcon>
      )}

      {isFurtherEnrichment && (
        <SecondaryButtonAndIcon
          $isSmall
          type="button"
          aria-haspopup="dialog"
          aria-label="Further Enrichment. Click to view more information."
          onClick={onClickFurtherEnrichment}
          data-selector="further-enrichment-pill"
        >
          Further Enrichment{' '}
          <TeachingLearningSequenceInlineSvg
            id="icon_blue_square"
            width={18}
            height={18}
          />
          <TeachingLearningSequenceInlineSvg
            id="icon_black_diamond"
            width={18}
            height={18}
          />
        </SecondaryButtonAndIcon>
      )}
    </TeachingLearningSequencePillWrapper>
  );
};

export default TeachingLearningSequenceCheckpointButtons;
